import { ProfitAnalysisPage } from "../../_shared/ProfitAnalysisPage";

export default function SoldEditPage() {
  return <ProfitAnalysisPage paType="sold" mode="edit" />;
}
